import TucsonHeroSection from "./components/HeroSection";
import TucsonStickyNav from "./components/StickyNav";
import TucsonProcessingTimeSection from "./components/ProcessingTimeSection";
import TucsonServicesSection from "./components/ServicesSection";
import TucsonLocalAreaSection from "./components/LocalAreaSection";
import TucsonTravelTimingSection from "./components/TravelTimingSection";
import TucsonDestinationsSection from "./components/DestinationsSection";
import TucsonTestimonialsSection from "./components/TestimonialsSection";
import TucsonAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import TucsonComparisonSection from "./components/ComparisonSection";
import TucsonMistakesSection from "./components/MistakesSection";
import TucsonHowItWorksSection from "./components/HowItWorksSection";
import TucsonFAQSection, { faqs } from "./components/FAQSection";
import TucsonHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import TucsonFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function TucsonPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Tucson"
        state="Arizona"
        stateAbbr="AZ"
        route="/cities/tucson"
        title="Emergency Passport Tucson, AZ — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Tucson, AZ — as fast as 24 hours. Serving University of Arizona students, Davis-Monthan AFB families, Raytheon engineers, and Southern Arizona residents. A+ BBB rated, registered State Dept. courier. No Phoenix agency drive required."
        geoPlacename="Tucson, Arizona"
        geoPosition="32.2226;-110.9747"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Arizona"
        statePageRoute="/states/arizona"
      />
      <TucsonHeroSection />
      <TucsonStickyNav />
      <TucsonProcessingTimeSection />
      <TucsonServicesSection />
      <TucsonLocalAreaSection />
      <TucsonTravelTimingSection />
      <TucsonDestinationsSection />
      <TucsonTestimonialsSection />
      <TucsonAcceptanceFacilitiesSection />
      <TucsonComparisonSection />
      <TucsonMistakesSection />
      <TucsonHowItWorksSection />
      <TucsonFAQSection />
      <TucsonHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/tucson" state="AZ" />
      <TucsonFinalCTA />
    </div>
  );
}